import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { SiteHeader } from "./components/SiteHeader";
import { SiteFooter } from "./components/SiteFooter";
import { FloatingAction } from "./components/RedlandComponents";
import { useSiteContent, ContentProvider } from "./context/ContentContext";
import { AuthProvider } from "./admin/auth";
import { ProtectedRoute, AdminLogin, AdminChangePassword, AdminForgot } from "./admin/AdminAuth";
import { AdminDashboard } from "./admin/Dashboard";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import Rates from "./pages/Rates";
import Memberships from "./pages/Memberships";
import GolfEvents from "./pages/GolfEvents";
import Banquets from "./pages/Banquets";
import BookTeeTime from "./pages/BookTeeTime";
import JuniorGolf from "./pages/JuniorGolf";
import JuniorCamp from "./pages/JuniorCamp";
import SandTrap from "./pages/SandTrap";
import ContactUs from "./pages/ContactUs";
import NotFound from "./pages/NotFound";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView(), 100);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function PublicSite() {
  const { contact } = useSiteContent();
  return (
    <>
      <SiteHeader />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/rates" element={<Rates />} />
          <Route path="/memberships" element={<Memberships />} />
          <Route path="/golf-events" element={<GolfEvents />} />
          <Route path="/book" element={<BookTeeTime />} />
          <Route path="/banquets" element={<Banquets />} />
          <Route path="/junior-golf" element={<JuniorGolf />} />
          <Route path="/junior-camp" element={<JuniorCamp />} />
          <Route path="/the-sand-trap" element={<SandTrap />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <SiteFooter />
      <FloatingAction href={contact.phoneHref} />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ContentProvider>
          <ScrollToTop />
          <Routes>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/forgot" element={<AdminForgot />} />
            <Route
              path="/admin/change-password"
              element={
                <ProtectedRoute allowChange>
                  <AdminChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/*" element={<PublicSite />} />
          </Routes>
        </ContentProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
